module.exports = __webpack_public_path__ + "img/26-ram-1500.c70e9f09.jpg";